import { render, staticRenderFns } from "./DevicePrintLabelsDialog.vue?vue&type=template&id=c8e480e8&scoped=true"
import script from "./DevicePrintLabelsDialog.vue?vue&type=script&lang=ts"
export * from "./DevicePrintLabelsDialog.vue?vue&type=script&lang=ts"
import style0 from "./DevicePrintLabelsDialog.vue?vue&type=style&index=0&id=c8e480e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e480e8",
  null
  
)

export default component.exports